import { getUser } from '@/services/auth.service'

const organisation = {
  namespaced: true,
  state: {
    organisationId: String,
    users: []
  },
  mutations: {
    SET_ORGANISATION(state, organisation) {
      state.organisationId = organisation._id
    },
    SET_USERS(state, users) {
      state.users = users
    },
    ADD_USER(state, user) {
      state.users.push(user)
    },
    UPDATE_USER(state, user) {
      state.users = state.users.map(u => (u = u._id === user._id ? user : u))
    }
  },
  actions: {
    async fetchUsers({ commit }) {
      try {
        const organisationId = getUser().organisationId
        const { data } = await this.$api.fetchUsers(organisationId)
        console.log({ data })
        commit('SET_USERS', data)
        return Promise.resolve()
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async createNewUser({ commit }, user) {
      try {
        user.email.trim()
        const { data } = await this.$api.createNewUser(user)
        console.log({ data })
        commit('ADD_USER', data)
        return Promise.resolve(data)
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async updateUser({ commit }, user) {
      try {
        const { data } = await this.$api.updateUser(user)
        commit('UPDATE_USER', data)
        return Promise.resolve(data)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  getters: {
    users: state => state.users,
    auditors: state =>
      state.users.filter(user => user.role !== 'admin' || user.role !== 'super')
  }
}

export default organisation
